import type { ClientStatus } from '@trellis/shared'

export const CLIENT_STATUS_STYLES: Record<ClientStatus, { pill: string; dot: string }> = {
  ACTIVE: { pill: 'bg-green-50 text-green-700', dot: 'bg-green-500' },
  INACTIVE: { pill: 'bg-stone-100 text-stone-500', dot: 'bg-stone-400' },
  PROSPECT: { pill: 'bg-blue-50 text-blue-700', dot: 'bg-blue-500' },
}

export const CLIENT_STATUS_LABELS: Record<ClientStatus, string> = {
  ACTIVE: 'Active',
  INACTIVE: 'Inactive',
  PROSPECT: 'Prospective client',
}
